/**
 * Erreurs liées à l'IA et aux traductions
 */

import { ERROR_CODES } from '@repo/contracts/errors';

import { ErrorConfigWithCallback } from './types';

export const AI_ERRORS: Record<string, ErrorConfigWithCallback> = {
    [ERROR_CODES.AI_ACTION_TRANSLATE_TARGET_LANGUAGE_REQUIRED]: {
        messageKey: 'select-a-language',
        severity: 'error',
    },
    [ERROR_CODES.AI_ACTION_TRANSLATE_TARGET_LANGUAGE_EQUALS_SOURCE_LANGUAGE]: {
        messageKey: 'cannot-translate-to-the-same-language',
        severity: 'error',
    },
    [ERROR_CODES.AI_REQUEST_NOT_FOUND]: {
        messageKey: 'the-enrichment-improvement-is-no-longer-available',
        severity: 'error',
        callbackable: true,
        callbackDescription: 'Ferme le modal de création AI et réinitialise les données',
    },
    [ERROR_CODES.NO_CREDITS]: {
        messageKey: 'you-no-longer-have-the-required-credits',
        severity: 'error',
    },
    [ERROR_CODES.AI_ACTIVE_CONFIG_NOT_FOUND]: {
        messageKey: 'unable-to-retrieve-active-ai-configuration',
        severity: 'error',
    },
    [ERROR_CODES.AI_PROMPT_NOT_FOUND]: {
        messageKey: 'unable-to-retrieve-ai-prompt',
        severity: 'error',
    },
    [ERROR_CODES.AI_COMPLETION_FAILED]: {
        messageKey: 'ai-text-generation-failed',
        severity: 'error',
    },
    [ERROR_CODES.AI_PROMPT_TOO_LARGE]: {
        messageKey: 'submitted-data-is-too-large-reduce-sources-or-action-period',
        severity: 'error',
    },
    [ERROR_CODES.AI_PROMPT_TOO_LARGE_INCOMPLETE_WEBSETTINGS]: {
        messageKey: 'submitted-data-is-too-large-reduce-sources-or-action-period',
        severity: 'error',
    },
    [ERROR_CODES.AI_PARSE_FAILED]: {
        messageKey: 'unable-to-parse-ai-generated-data',
        severity: 'error',
    },
    [ERROR_CODES.AI_REQUEST_NO_CREDITS]: {
        messageKey: 'the-enrichment-improvement-quota-is-exceeded',
        severity: 'error',
        callbackable: true,
    },
    [ERROR_CODES.AI_SERVER_ERROR]: {
        messageKey: 'the-connection-with-the-ai-is-temporarily-interrupted-please-try-again-later',
        severity: 'error',
    },
    [ERROR_CODES.AI_TIMEOUT]: {
        messageKey: 'the-connection-with-the-ai-is-temporarily-interrupted-please-try-again-later',
        severity: 'error',
    },
    [ERROR_CODES.AI_RATE_LIMIT]: {
        messageKey: 'the-connection-with-the-ai-is-temporarily-interrupted-please-try-again-later',
        severity: 'error',
    },
    [ERROR_CODES.AI_UNKNOWN_ERROR]: {
        messageKey: 'the-connection-with-the-ai-is-temporarily-interrupted-please-try-again-later',
        severity: 'error',
    },
    [ERROR_CODES.AI_RESPONSE_INVALID_WEIGHTS]: {
        messageKey: 'unable-to-parse-ai-generated-data',
        severity: 'error',
    },
};
